<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="container-fluid d-flex justify-content-center pt-3 my-0 px-1 mb-1">
  <div class="row w-100 justify-content-center no-user-select">
    <div
      class="col-12 col-md-8 d-flex flex-column justify-content-center gap-3"
    >
      <app-invite-card (rsvpClick)="openRsvpModal()"></app-invite-card>
      <app-countdown
        class="no-user-select"
        (click)="triggerConfetti()"
        #countdownComponent
      ></app-countdown>
      <app-venue></app-venue>
      <kith-kin
        class="d-block"
        *ngIf="kithKinConfig.show"
        [menuItems]="kithKinConfig.menuItems"
      ></kith-kin>

      <div class="col-12 d-flex flex-row justify-content-between gap-2">
        <a
          class="col"
          [routerLink]="
            tenantService.getTenantPrefixedPath(
              galleryCardConfig.menuItems[0].routeUrl
            )
          "
          *ngIf="galleryCardConfig.show"
        >
          <app-gallery-card></app-gallery-card>
        </a>
        <a
          class="col-organiser-card text-decoration-none d-none d-md-block"
          [routerLink]="
            tenantService.getTenantPrefixedPath('event/eventOrganizers')
          "
          *ngIf="eventOrganisersConfig.show"
        >
          <div class="border-card text-start">
            <div class="border-card-content">
              <h3 class="border-card-title">
                Our <span class="gradient-text">Organizers</span>
              </h3>
              <p class="organizer-subtext">Behind the scenes heroes</p>
            </div>
            <div class="organizer-icon">
              <span class="arrow-icon">&#8594;</span>
            </div>
          </div>
        </a>
      </div>
      <!-- 
      <home-ride-share *ngIf="rideShareConfig.show"></home-ride-share>
      <home-exclusive-card *ngIf="showExclusiveCard()"></home-exclusive-card> -->
    </div>
  </div>
</div>

<div
  class="container-fluid sticky-bottom-buttons d-flex col-md-8 justify-content-center align-items-center text-center gap-2 px-3"
>
  <div class="col-6 ps-1 ps-md-0">
    <a
      [routerLink]="tenantService.getTenantPrefixedPath('event/guestBook')"
      rel="noopener noreferrer"
      class="btn-pill-outline text-decoration-none cursor-pointer w-100"
    >
      View &amp; Post Wishes
    </a>
  </div>
  <div class="col-6 pe-1 pe-md-0">
    <a
      class="btn-pill-solid text-decoration-none cursor-pointer w-100"
      routerLink="event/photoBooth"
    >
      Photo Booth
    </a>
  </div>
</div>

<invite-rsvp *ngIf="showRsvpModal" (onClose)="closeRsvpModal()"></invite-rsvp>
